import React, {  useState , useEffect} from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {

  Card,
  CardBody,

  Container,

  Row,

} from "reactstrap";


import SweetAlert from "react-bootstrap-sweetalert";

// Redux
import { connect,useDispatch} from "react-redux";
import { withRouter,  useHistory } from "react-router-dom";

import { contactsCreate } from "../../store/contacts/actions";



//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"
import Loader from "../../components/Common/Loader";
import { contactsList } from "../../store/contacts/actions";


import ContactoForm from "./components/ContactoForm";



const ContactsCreate = (props) => {
  
  const history = useHistory();
  const dispatch= useDispatch();

  const [datos, estableceDatos] = useState({
  });

 
 
    const hijoAPadre = (datoshijo) => {
      estableceDatos(datoshijo);
      
    }

   
 
  

  useEffect(() => {
  
    dispatch(contactsList());
  
  },[dispatch]);

 

  const optionGroupTipoCliente = [
    {

      options: [
        { label: "CLIENTE ANTIGUO", value: "CLIENTE ANTIGUO" },
        { label: "CLIENTE NUEVO", value: "CLIENTE NUEVO" },
        { label: "PROVEEDOR", value: "PROVEEDOR" },
      
      ],
    },

  ];


  console.log(props.children)



  const redirect = () => {
    history.goBack();
  };
 

  const goback = () => {
    history.goBack()
  };

   return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>tccontrol| Contactos</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"tccontrol"} breadcrumbItem={"Agregar Contactos"} />
          {props.loading ? (
            <Loader />
          ) : (
            <Card className= "col-lg-8 mx-auto  mt-3">
              {props.contactsCreated.id ? (
                <SweetAlert
                  title="Hecho!"
                  success
                  timeout={1000}
                  showConfirm={false}
                  onConfirm={() => {
                    props.location.state?goback():redirect()
                  }}
                >
                  Se ha agregado el Contacto
                </SweetAlert>
              ) : null}
              <CardBody>
        
                <h4 className="card-title">Empresa y/o Persona Natural </h4>
        
   
              
                <Row className="form-control needs-validation"  >
             

                   
                    <ContactoForm
                      optionGroupTipoCliente ={optionGroupTipoCliente}
                      hijoAPadre={hijoAPadre}
                      datos={datos}
                    >

                    </ContactoForm>
             
                       
                    
                          
                </Row>
              </CardBody>
            </Card>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, contactsCreated } = state.Contacts;
  return { error, loading, contactsCreated};
};

contactsCreate.propTypes = {
  error: PropTypes.any,
  loading: PropTypes.bool,
  contactsCreated: PropTypes.object,
};
export default withRouter(connect(mapStateToProps, { contactsCreate })(ContactsCreate));
